<template>
  <div>
    <span class="detail-number-pager">
      <BaseButton
          :disabled="disabledPrevious"
          icon="el-icon-d-arrow-left"
          @click="moveArrayList(-1)" />
      <h3 :style="textStyle">{{ title }}： {{ id }}</h3>
      <BaseCopyButton
          :text="id || ''" />
      <BaseButton
          :disabled="disabledNext"
          icon="el-icon-d-arrow-right"
          @click="moveArrayList(1)" />
    </span>
  </div>
</template>

<script>
import * as define from '@/define'
import x from '@/components/mixins/mixin'

import BaseButton from '@/components/atoms/BaseButton'
import BaseCopyButton from '@/components/molecules/BaseCopyButton'

export default {
  name: 'BaseDetailMoveData',
  components: {
    BaseButton,
    BaseCopyButton
  },
  mixins: [x],
  props: {
    title: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    routerPath: {
      type: String,
      default: null
    },
    listIndex: {
      type: Number,
      default: null
    },
    mode: {
      type: Number,
      default: null
    },
    arrayLists: {
      type: Array,
      default: () => {}
    },
    pathParameter: {
      type: Array,
      default: () => {}
    },
    canMoveData: {
      type: Boolean,
      default: true
    },
    textStyle: {
      type: String,
      default: null
    }
  },
  computed: {
    disabledNext () {
      if (this.mode === define.MODE.NORMAL && this.arrayLists.length !== 0 && this.listIndex >= 0 && this.canMoveData) {
        return this.arrayLists.length <= this.listIndex + 1
      } else {
        return true
      }
    },
    disabledPrevious () {
      if (this.mode === define.MODE.NORMAL && this.arrayLists.length !== 0 && this.listIndex >= 0 && this.canMoveData) {
        return this.arrayLists.length - this.listIndex >= this.arrayLists.length
      } else {
        return true
      }
    }
  },
  methods: {
    /**
     * 表示するデータを移動します。
     * @param {Number} index 移動 index 数
     */
    moveArrayList: async function (index) {
      // 更新対象の Index の取得
      let newIndex = this.listIndex + Number(index)

      // URL を更新する. 詳細データの再取得は各コンポーネントの beforeRouteUpdate で行う.
      const path = this.routerPath + this.$_mixin_getData(this.arrayLists[newIndex], this.pathParameter, '&')
      this.$router.push({ path: path }, () => { this.$emit('changeIndex', newIndex) })
      if (path === this.$route.path) {
        try {
          this.$loadingService.show()
          this.$emit('changeIndex', newIndex)
        } finally {
          this.$loadingService.close()
        }
      }
    }
  }
}
</script>
